// extracted by mini-css-extract-plugin
module.exports = {"promotional-messages":"promotional-messages_promotional-messages__1Wim_"};